import React, {useCallback, useEffect} from 'react';
import Tab from '../../../../../elements/Tabs/Tab';
import Icon from '../../../../../elements/icons/Icon';
import {useEventSettings} from '../../../../../../data/hooks/events/useEventSettings';
import {isCategoryParticipantsFilterTabActive} from './isCategoryParticipantsFilterTabActive';
import {useDispatch} from 'react-redux';
import {useParticipantsCategories} from '../../../../../../data/hooks/participant/useParticipantsCategories';
import { useRecommendedParticipantsFilter } from '../../../../../../data/hooks/participant/useRecommendedParticipantsFilter';
import { isCategoriesFilterTabVisible } from './isCategoriesFilterTabVisible';

const CATEGORY_FILTER = {
    categories: {},
};

function CategoryFilterParticipants(props) {
    const {className = '', eventId, filterParams} = props,
        categories = useParticipantsCategories(eventId),
        suggestedFilterParams = useRecommendedParticipantsFilter(eventId),
        selected = isCategoryParticipantsFilterTabActive(filterParams, suggestedFilterParams),
        settings = useEventSettings(eventId),
        dispatch = useDispatch();

    const handleClick = useCallback(() => {
        if (!filterParams.categories) {
            dispatch(app.actions.participants.setFilterParams(eventId, CATEGORY_FILTER));
        }
        app.history.push('./filter');
    }, [eventId, filterParams]);

    if (!isCategoriesFilterTabVisible(categories)) return null;

    return (
        <Tab className={className} selected={selected} onClick={handleClick}>
            <Icon src="/img/filter_icon.png" color={selected ? 'white' : settings.secondary_color} />
        </Tab>
    );
}

export default CategoryFilterParticipants;
